var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recomended-slider"},[_c('CardSlider',{attrs:{"items":_vm.recomended,"sliderOptions":_vm.sliderOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }